function slugify(str = "") {
  return str
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")        // spaces → hyphens
    .replace(/[^\w-]+/g, "")     // remove non-word chars
    .replace(/--+/g, "-")        // collapse multiple hyphens
    .replace(/^-+|-+$/g, "");    // trim leading/trailing hyphens
}

/**
 * Build a slug from car data
 * Pattern: /buy-cars/:city/:brand/:model/:variant-:year/:id
 * Example: /buy-cars/ujjain/hyundai/santro/era-plus-2019/3
 */
export function buildCarSlug(car) {
  const city     = slugify(car.location || "india");
  const brand    = slugify(car.brand    || "car");
  const model    = slugify(car.model    || "unknown");
  const variant  = slugify(car.variant  || "");
  const year     = car.year || "";
  const id       = car.id;

  // variant + year combined, e.g. "era-plus-2019" or just "2019"
  const variantYear = variant ? `${variant}-${year}` : `${year}`;

  return `/buy-cars/${city}/${brand}/${model}/${variantYear}/${id}`;
}

/**
 * Extract the numeric car ID from any slug pattern
 * Works for both /car/3 and /buy-cars/ujjain/hyundai/santro/era-2019/3
 */
export function extractCarId(slug) {
  if (!slug) return null;
  // The ID is always the last path segment
  const parts = slug.replace(/^\/|\/$/g, "").split("/");
  const last = parts[parts.length - 1];
  const id = parseInt(last, 10);
  return isNaN(id) ? null : id;
}